__webpack_require__.p = "https://assets.appcenter.ms/generated/";